import Immutable from 'immutable';
import {
  FLAG_GETTING_BUSES_BODY_WORKS,
  GET_BUSES_BODY_WORKS,
  CLEAR_BUSES_BODY_WORKS,
  GET_BUS_BODY_WORK,
  FLAG_BUSES_BODY_WORKS_ACTIVITY,
  CLEAR_BUS_BODY_WORK,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    loading: Immutable.List(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUSES_BODY_WORKS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUSES_BODY_WORKS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUSES_BODY_WORKS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_BUS_BODY_WORK:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case FLAG_BUSES_BODY_WORKS_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case CLEAR_BUS_BODY_WORK:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
